import React from "react";
import PropTypes from "prop-types";

import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

/* =========================================================
   STATUS OPTIONS
========================================================= */

const STATUS_OPTIONS = [
  {
    label: "Blocked",
    value: "7",
  },
  {
    label: "Do Not Reserve",
    value: "8",
  },
];

const EditRoomNoFloorAssignForm = ({
  fields,
  values,
  errors,
  handleChange,
  handleSubmit,
  loading,
}) => {
  return (
    <PageBody
      onSubmit={handleSubmit}
      headerchildren={
        <HeadingOne>
          Update Room Floor Assignment
        </HeadingOne>
      }
    >
      {fields.map((field) => {
        /* ================================================
           STATUS
        ================================================ */

        if (field.name === "status") {
          return (
            <div
              className={field.fieldSize}
              key={field.name}
            >
              <label className="form-label">
                {field.label}

                {field.required && (
                  <span className="text-danger">
                    {" "}*
                  </span>
                )}
              </label>

              <select
                className={`form-select ${errors[field.name]
                  ? "is-invalid"
                  : ""
                  }`}
                name={field.name}
                value={
                  values[field.name] ?? ""
                }
                onChange={handleChange}
              >
                <option value="">
                  Select Status
                </option>

                {STATUS_OPTIONS.map(
                  (option) => (
                    <option
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ),
                )}
              </select>

              {errors[field.name] && (
                <div className="invalid-feedback">
                  {errors[field.name]}
                </div>
              )}
            </div>
          );
        }

        /* ================================================
           NORMAL INPUT
        ================================================ */

        return (
          <FormInput
            key={field.name}
            field={field}
            value={
              values[field.name] ?? ""
            }
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      <FormSubmitButton
        label="Update"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

EditRoomNoFloorAssignForm.propTypes = {
  fields: PropTypes.array.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default EditRoomNoFloorAssignForm;